export const variousAsn = 'VARIOUS';
